export const variousAsn = 'VARIOUS';
